module.exports = ".row{\r\n    margin: 20px 0px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/general-transaction/validate-accounts/validate-accounts/validate-accounts.component.css
// module id = ./src/app/general-transaction/validate-accounts/validate-accounts/validate-accounts.component.css
// module chunks = main